export const CLINICAL_ANALYSIS_ACTIONS = {
    GET: 'CLINICAL_ANALYSIS_GET',
    GET_INDIVIDUAL: 'CLINICAL_ANALYSIS_GET_INDIVIDUAL',
    GET_INBOX: 'CLINICAL_ANALYSIS_GET_INBOX',
    GET_OUTBOX: 'CLINICAL_ANALYSIS_GET_OUTBOX',
    GET_SHEET: 'CLINICAL_ANALYSIS_GET_SHEET',
    SUCCESS_UPLOAD_FILE: 'CLINICAL_ANALYSIS_SUCCESS_UPLOAD_FILE',

    FIND: 'CLINICAL_ANALYSIS_FIND',
    FIND_INDIVIDUALS: 'CLINICAL_ANALYSIS_FIND_INDIVIDUALS',
    FIND_SAMPLES: 'CLINICAL_ANALYSIS_FIND_SAMPLES',
    FIND_ATTACHMENTS: 'CLINICAL_ANALYSIS_FIND_ATTACHMENTS',

    TRACEABILITY: 'CLINICAL_ANALYSIS_TRACEABILITY',
    RESET: 'CLINICAL_ANALYSIS_RESET',
    CLEAN: 'CLINICAL_ANALYSIS_CLEAN',
    CLEAN_IMPORTS: 'CLINICAL_ANALYSIS_CLEAN_IMPORTS',
    UPDATE: 'CLINICAL_ANALYSIS_UPDATE',
    SUCCESS: 'CLINICAL_ANALYSIS_SUCCESS',
    ERROR: 'CLINICAL_ANALYSIS_ERROR',

    GET_TYPES: 'CLINICAL_ANALYSIS_GET_TYPES',

    CREATE_REPORT: 'CLINICAL_ANALYSIS_CREATE_REPORT' 
}